<template>
    <ValidationObserver ref="form" v-slot="{handleSubmit}">
        <vs-row>
            <vs-col vs-w="6">
                <div class="ml-2 mr-2">
                    <ValidationProvider
                        vid="countries"
                        :name="$t('global.Countries')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label class="vs-input--label block w-full">{{$t('global.Countries')}}</label>
                        <v-select
                            class="w-full"
                            name="country"
                            multiple
                            clearSearchOnSelect
                            appendToBody
                            :clearable="false"
                            :closeOnSelect="false"
                            v-model="countries"
                            :options="locales.countries"
                            :reduce="country => country.id"
                            label="country"
                            :calculate-position="withPopper"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="ml-2 mr-2">
                    <ValidationProvider
                        vid="language"
                        :name="$t('global.Language')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label class="vs-input--label block w-full">{{$t('global.Language')}}</label>
                        <v-select
                            class="w-full"
                            appendToBody
                            v-model="language"
                            :options="locales.languages"
                            :reduce="language => language.iso_2"
                            label="language"
                            :clearable="false"
                            :calculate-position="withPopper"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="12">
                <div class="ml-2 mt-4 mr-2">
                    <ValidationProvider
                        vid="teams"
                        :name="$t('global.Teams')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                    <label class="vs-input--label block w-full">{{$t('global.Teams')}}</label>
                    <v-select
                        class="w-full"
                        multiple
                        clearSearchOnSelect
                        appendToBody
                        :closeOnSelect="false"
                        v-model="teams"
                        :options="teamsOptions"
                        :reduce="team => team.id"
                        label="name"
                        :clearable="false"
                        :calculate-position="withPopper"
                    />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="ml-2 mt-4 mr-2">
                    <label class="vs-input--label block w-full">{{$t('global.Start')}}</label>
                    <vs-input class="inputx w-full" type="time" v-model="start" />
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="ml-2 mt-4 mr-2">
                    <label class="vs-input--label block w-full">{{$t('global.End')}}</label>
                    <vs-input class="inputx w-full" type="time" v-model="end" />
                </div>
            </vs-col>
            <vs-col vs-w="12">
                <div class="text-right mt-4 ml-2 mr-2">
                    <vs-button @click="handleSubmit(send)" color="primary" type="filled">{{ $t('buttons.Save') }}</vs-button>
                </div>
            </vs-col>
        </vs-row>
        </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select'
import send from '@/utils/fetch'
import ErrorHandler from '@/utils/errorHandler'
import EventBus from '@/store/eventBus'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {vSelectPosition} from "@/utils/mixins";

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition],

    data() {
        return {
            countries: [],
            language: null,
            teams: [],
            locales: {},
            teamsOptions: [],
            start: '09:00',
            end: '20:00'
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    methods: {
        async send() {
            try {
                const data = {
                    country_ids: this.countries,
                    language: this.language,
                    team_ids: this.teams,
                    start: this.start,
                    end: this.end
                }

                if(this.popupType === 'createSettingSms') {
                    await send(this.$url['sms-settings'].create, 'POST', {data})
                }

                if(this.popupType === 'updateSettingSms') {
                    data.id = this.popupData.id
                    await send(this.$url['sms-settings'].update, 'PUT', {data})
                }

                EventBus.$emit('responseCreateSMSSetting')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (error) {

                if(error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(error).send
            }
        },

        async getTeams() {
            try {
                this.teamsOptions = await send(this.$url.team.get, 'GET').then(data => data.data.result)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getLocales() {
            try {
                const geo = await send(this.$url.geo.get, 'GET').then(data => data.data.result)
                const sms = await send(this.$url['sms-message'].get, 'GET').then(data => data.data.result)
                if(sms.length) {
                    const arr = [...new Set(sms.map(element => element.language))]
                    const languages = arr.map(element => geo.languages.find(el => el.iso_2 === element))

                    this.$set(this.locales, 'languages', languages)
                }

                const countries = geo.countries
                this.$set(this.locales, 'countries', countries)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initToEdit() {
            this.start = this.popupData.start
            this.countries = this.popupData.country_ids.map(element => element.id)
            this.teams = this.popupData.team_ids.map(element => element.id)
            this.language =  this.popupData.language
        }
    },

    async mounted() {
        await this.getLocales()
        await this.getTeams()

        if(this.popupType === 'updateSettingSms') {
            this.initToEdit()
        }
    }
}
</script>
